export const deliveryReport = {
	title: "Informes de Delivery",
	description: "Dé seguimiento y analice las entregas de delivery de su establecimiento.",
	tabs: {
		general: "Informe general",
	},
	selectPeriod: "Seleccione un período",
	periodOptions: {
		today: "Hoy",
		last7days: "Últimos 7 días",
		last15days: "Últimos 15 días",
		last30days: "Últimos 30 días",
		last90days: "Últimos 90 días",
		custom: "Seleccionar un período",
	},
	generalTab: {
		export: "Exportar",
		filtersToolbar: {
			search: "Buscar n° del pedido",
			vendors: "Plataforma",
			vendorsPlaceholder: "Seleccionar plataforma",
			status: "Estado",
			statusPlaceholder: "Seleccionar estado",
			period: "Período",
			periodPlaceholder: "Seleccionar período",
			back: "Volver",
			apply: "Aplicar",
		},
		table: {
			columns: {
				vendor: "Plataforma",
				reference: "Pedido N°",
				status: "Estado",
				date: "Fecha",
				orderCreatedAt: "Hora del Pedido",
				orderEndAt: "Pedido Finalizado",
				value: "Total",
				viewMore: "Ver Más",
			},
			summary: "Total del período",
			seeMore: "Ver más detalles",
		},
		vendorType: {
			rappi: "Rappi",
			coala: "Coala",
			ifood: "iFood",
			keeta: "Keeta",
			food99: "99Food",
		},
		orderStatus: {
			cancelled: "Cancelado",
			concluded: "Concluido",
			confirmed: "Confirmado",
		},
		orderDetailsDrawer: {
			orderRangeWithEnd:
				"Pedido realizado el {{startDate}} a las {{startHour}}<br>Finalizado a las {{endHour}}",
			orderRangeWithoutEnd: "Pedido realizado el {{startDate}} a las {{startHour}}",
			order: "Pedido",
			paymentDetails: "DETALLE FINANCIERO",
			paymentMethod: "Forma de pago",
			subTotal: "Subtotal de la venta",
			discountAndImpost: "Tarifas y descuentos",
			orderTotal: "Total del pedido",
			deliveryTypeLabel: "Tipo de entrega",
			deliveryTypeValues: {
				dineIn: "Consumo en el local",
				pickUp: "Recoger en tienda",
				delivery: "Entrega",
				deliveryByPartner: "Entrega por socio",
				deliveryByRestaurant: "Entrega por la tienda",
				deliveryByMarketplace: "Entrega por marketplace",
				onlineFicha: "Ficha en línea",
				onlineTab: "Cuenta en línea",
				viewMenu: "Ver menú",
			},
			discountValue: "-{{value}} - Cupón de descuento",
			discountValueDeliveryFee: "-{{value}} - Descuento en la tarifa de entrega",
			discountValueDeliveryFeeMarketplace:
				"-{{value}} - Descuento en la tarifa de entrega de {{marketplace}}",
			discountValueMarketplace: "-{{value}} - Descuento de {{marketplace}}",
			deliveryFee: "{{value}} - Tarifa de Entrega",
			tip: "{{value}} - Gratificación",
			tipReceiver: {
				MERCHANT: "Propina de la tienda",
				LOGISTIC_SERVICES: "Propina del repartidor",
				MARKETPLACE: "Propina del marketplace",
			},
			orderFee: "{{value}} - {{name}}",
			feeNames: {
				serviceFee: "Tarifa de servicio",
				minimumOrderFee: "Tarifa de pedido mínimo",
			},
			fees: "{{value}} - Tarifas",
			feesTooltip: "Incluye la tarifa mínima de pedido y la tarifa de servicio",
			paymentMethodType: {
				creditCardInPlace: "Tarjeta de crédito",
				creditCardOnline: "Tarjeta de crédito",
				debitCardOnline: "Tarjeta de débito",
				debitCardInPlace: "Tarjeta de débito",
				cash: "Efectivo",
				voucherInPlace: "Voucher",
				ame: "Ame",
				pix: "Pix",
			},
		},
	},
	orderItemsTable: {
		columns: {
			count: "Cant.",
			name: "Elemento",
			baseUnitPrice: "V. Unitario",
			totalUnitPrice: "Subtotal",
		},
		summary: "Subtotal",
		totalReceive: "TOTAL A RECIBIR",
		totalReceiveNoteIncludes: "Incluye la tarifa de entrega (entrega por la tienda)",
		totalReceiveNoteExcludes: "No incluye la tarifa de entrega (entrega externa)",
	},
	orderStatus: {
		ready: "Listo",
		canceled: "Cancelado",
		concluded: "Concluido",
		confirmed: "Confirmado",
		dispatched: "Despachado",
		integrated: "Integrado",
		placed: "Creado",
		pendingPayment: "Pago pendiente",
		pickupAreAssigned: "Cliente en el local",
		scheduled: "Programado",
	},
};
